import { render } from "./ProdutoImagens.vue?vue&type=template&id=1e77eafd&scoped=true&ts=true"
import script from "./ProdutoImagens.vue?vue&type=script&lang=ts"
export * from "./ProdutoImagens.vue?vue&type=script&lang=ts"

import "./ProdutoImagens.vue?vue&type=style&index=0&id=1e77eafd&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e77eafd"]])

export default __exports__